import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginCurrencyHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import { marginScrollService } from "../../../../service/marginFiles/marginScrollService";

export interface IMarginCurrencyTableMobProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginCurrencyTableMob: React.FC<IMarginCurrencyTableMobProps> = (props) => {
	const scrollBodyRef = React.useRef<HTMLUListElement>(null);
	const fixedBodyRef = React.useRef<HTMLUListElement>(null);
	const scrollHeadRef = React.useRef<HTMLUListElement>(null);

	return (
		<div className="mrgn_curr_tbl margin_table_mob">
			<div className="fixed_col">
				<ul className="hdr_row">
					<li className="tr">
						<div className="td">
							<span className="sort_cont trdSym">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="trdSym"
									onSort={props.sortProps.onSort}
									colName={marginCurrencyHeading.trdSym}
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={fixedBodyRef}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="trdSym ib" dangerouslySetInnerHTML={{ __html: row.trdSym }}></span>
							</div>
						</li>
					))}
				</ul>
			</div>

			<div className="scrolling_cont">
				<ul className="hdr_row" ref={scrollHeadRef}>
					<li className="tr">
						<div className="td">
							<span className="sort_cont LotSize">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="LotSize"
									onSort={props.sortProps.onSort}
									colName={marginCurrencyHeading.lotSize}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont SPANMarginAmt">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SPANMarginAmt"
									onSort={props.sortProps.onSort}
									colName={marginCurrencyHeading.spanMarginAmt}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ExpMarginamt">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ExpMarginamt"
									onSort={props.sortProps.onSort}
									colName={marginCurrencyHeading.expMarginamt}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMarginamt">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMarginamt"
									onSort={props.sortProps.onSort}
									colName={marginCurrencyHeading.totalMarginamt}
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont SPANMarginper">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="SPANMarginper"
									onSort={props.sortProps.onSort}
									colName="Span Margin %"
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont ExpMarginper">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="ExpMarginper"
									onSort={props.sortProps.onSort}
									colName="Exposure Margin %"
								/>
							</span>
						</div>
						<div className="td">
							<span className="sort_cont TotalMarginper">
								<MarginSort
									sortList={props.filteredData}
									sortedColName={props.sortProps.sortedColumnState.colName}
									sortKey="TotalMarginper"
									onSort={props.sortProps.onSort}
									colName="Total Margin %"
								/>
							</span>
						</div>
					</li>
				</ul>
				<ul className="data_rows" ref={scrollBodyRef} onScroll={() => marginScrollService(scrollBodyRef, fixedBodyRef, scrollHeadRef)}>
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td">
								<span className="LotSize ib">{row.LotSize}</span>
							</div>
							<div className="td">
								<span className="SPANMarginAmt ib">{toINR(row.SPANMarginAmt)}</span>
							</div>
							<div className="td">
								<span className="ExpMarginamt ib">{toINR(row.ExpMarginamt)}</span>
							</div>
							<div className="td">
								<span className="TotalMarginamt ib">{toINR(row.TotalMarginamt)}</span>
							</div>
							<div className="td">
								<span className="SPANMarginper ib">{toINR(row.SPANMarginper)}</span>
							</div>
							<div className="td">
								<span className="ExpMarginper ib">{toINR(row.ExpMarginper)}</span>
							</div>
							<div className="td">
								<span className="TotalMarginper ib">{toINR(row.TotalMarginper)}</span>
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default MarginCurrencyTableMob;
